// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'

import compLoader from './components/Loader'

import VueI18n from 'vue-i18n'
import { messages } from './translations/messages'
import { lang } from './translations/lang'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import './assets/css/global.css'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)

Vue.use(VueMaterial)

Vue.component('app-loader', compLoader)

/**
 * Vue-i18n
 */
const numberFormats = {
  pl: {
    currency: {
      style: 'currency',
      currency: 'PLN',
      currencyDisplay: 'symbol'
    }
  },
  en: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    }
  }
}
Vue.use(VueI18n)
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: lang, // set locale
  fallbackLocale: 'pl', // when no EN translate
  messages, // set locale messages
  numberFormats
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js